import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gradient-dark border-t border-sky-blue/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-cta rounded-lg flex items-center justify-center shadow-neon">
                <span className="text-white font-bold text-lg">RV</span>
              </div>
              <span className="text-xl font-bold gradient-text-neon">
                Residual Vault
              </span>
            </div>
            <p className="text-sky-blue mb-4 max-w-sm">
              Compare 156+ DeFi staking protocols with live APY data, risk ratings, and side-by-side analysis. Free to use.
            </p>
            <div className="flex gap-4">
              <a href="https://x.com/ResidualVault" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-steel-blue/20 hover:bg-steel-blue/30 rounded-lg flex items-center justify-center text-sky-blue hover:text-neon-red transition-all">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/residual-vault" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-steel-blue/20 hover:bg-steel-blue/30 rounded-lg flex items-center justify-center text-sky-blue hover:text-neon-red transition-all">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="mailto:support@residualvault.com" className="w-10 h-10 bg-steel-blue/20 hover:bg-steel-blue/30 rounded-lg flex items-center justify-center text-sky-blue hover:text-neon-red transition-all">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-cream font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/staking" className="text-sky-blue hover:text-neon-red transition-colors">Staking Options</Link></li>
              <li><Link to="/calculator" className="text-sky-blue hover:text-neon-red transition-colors">Calculator</Link></li>
              <li><Link to="/leaderboard" className="text-sky-blue hover:text-neon-red transition-colors">Leaderboard</Link></li>
              <li><Link to="/blog" className="text-sky-blue hover:text-neon-red transition-colors">Blog</Link></li>
              <li><Link to="/pricing" className="text-sky-blue hover:text-neon-red transition-colors">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-cream font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sky-blue hover:text-neon-red transition-colors">About</Link></li>
              <li><Link to="/education" className="text-sky-blue hover:text-neon-red transition-colors">Education</Link></li>
              <li><Link to="/terms" className="text-sky-blue hover:text-neon-red transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-sky-blue hover:text-neon-red transition-colors">Privacy Policy</Link></li>
              <li><a href="mailto:support@residualvault.com" className="text-sky-blue hover:text-neon-red transition-colors">Contact</a></li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-sky-blue/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sky-blue text-sm">
            © {new Date().getFullYear()} Residual Vault, LLC. All rights reserved.
          </p>
          <p className="text-sky-blue/60 text-sm">
            Crypto staking intelligence platform
          </p>
        </div>

      </div>
    </footer>
  );
}
